import React, { useState } from "react";
import {Dropdown} from "semantic-ui-react";

const DropDownLabel = ({label, data, className, handleLabelOnClick, value}) => {
    
    return ( 
        <Dropdown
            options={data}
            scrolling
            placeholder="select"
            value={value}
            disabled={true}
        />
     );
}
 
export default DropDownLabel;